export const constants = {
  spacing: 11
};

export function spacing(factor) {
  return Math.ceil(constants.spacing * factor);
}
